import { DotIndicator, DotIndicatorRef } from '~/components/dot-indicator';
import { useScopedAtomValue } from '@lemon8/webapp-shared/component';
import { FC, useEffect, useRef } from 'react';
import { $NestedSwiperSlideInfo, $SlideToNestedIndex } from '~/components/article-gallery/atoms';

import './style.scss';

export const DotIndicatorSection: FC = () => {
  const nestedSwiperSlideInfo = useScopedAtomValue($NestedSwiperSlideInfo);
  const slideToNestedIndex = useScopedAtomValue($SlideToNestedIndex);
  const ref = useRef<DotIndicatorRef>(null);

  const handleIndicatorChange = (index: number): void => slideToNestedIndex(index);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    ref.current.changeTo(Math.min(nestedSwiperSlideInfo.current, nestedSwiperSlideInfo.length));
  }, [nestedSwiperSlideInfo.current]);

  return (
    <DotIndicator
      className="article-gallery-dots"
      count={nestedSwiperSlideInfo.length}
      ref={ref}
      onChange={handleIndicatorChange}
    />
  );
};
